import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ca796a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "mediacalBox" }
const _hoisted_4 = { class: "mediacalBack" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"mediaclText\" data-v-4ca796a0><div class=\"left\" data-v-4ca796a0><div class=\"sex\" data-v-4ca796a0>线索3:治疗前评估</div><div class=\"age\" data-v-4ca796a0>女，17岁</div></div></div><div class=\"bottom\" data-v-4ca796a0></div>", 2)
const _hoisted_7 = { class: "boxTail" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leftright" }, null, -1))
const _hoisted_9 = { class: "textBox" }
const _hoisted_10 = { class: "innerText" }
const _hoisted_11 = { class: "leftBox" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightBox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "topbox" }, [
    /*#__PURE__*/_createElementVNode("span", null, "主观评价")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "desttext" }, [
    /*#__PURE__*/_createTextVNode(" 药物评分:3"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("症状评分:2"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("生活质量评分(PQLQ)：66分"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_13 = { class: "innerText" }
const _hoisted_14 = { class: "leftBox" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightBox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "topbox" }, [
    /*#__PURE__*/_createElementVNode("span", null, "客观评价")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "desttext" }, [
    /*#__PURE__*/_createTextVNode(" 血清特异性lgE检测：血清lgE(+)；"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 尘螨(+) ")
  ])
], -1))
const _hoisted_16 = { class: "btnBox" }
const _hoisted_17 = { class: "bxs" }
const _hoisted_18 = { class: "ip" }
const _hoisted_19 = {
  style: {"width":"4rem","margin":"0 auto"},
  class: "home"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_question5 = _resolveComponent("question5")!
  const _component_correct = _resolveComponent("correct")!
  const _component_correct5 = _resolveComponent("correct5")!
  const _component_reason = _resolveComponent("reason")!
  const _component_jiexiao = _resolveComponent("jiexiao")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          src: require('../assets/logo.png')
        }, null, 8, ["src"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_van_image, {
                    class: "rightImg",
                    width: ".64rem",
                    height: ".6133rem",
                    src: require('../assets/duigou.png')
                  }, null, 8, ["src"])
                ]),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_van_image, {
                    class: "rightImg",
                    width: ".64rem",
                    height: ".6133rem",
                    src: require('../assets/duigou.png')
                  }, null, 8, ["src"])
                ]),
                _hoisted_15
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, $data.chatiShow]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_van_image, {
            onClick: $options.jiexiaoChanged,
            width: "2.44rem",
            height: "3.5333rem",
            src: require('../assets/zhentan.png')
          }, null, 8, ["onClick", "src"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_van_image, {
            onClick: $options.showPopup,
            width: "5.64rem",
            height: "1.3333rem",
            src: require('../assets/jxbtn.png')
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            class: "finger",
            width: "1.28rem",
            height: "1.28rem",
            src: require('../assets/dong.gif')
          }, null, 8, ["src"])
        ])
      ], 512), [
        [_vShow, $data.chatiShow]
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_van_popup, {
          show: $data.show,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event)),
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            ($data.flag == 'question')
              ? (_openBlock(), _createBlock(_component_question5, {
                  key: 0,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'correct')
              ? (_openBlock(), _createBlock(_component_correct, {
                  key: 1,
                  onOnChanged: $options.updateCorrect,
                  postaimqus: $data.postaimqus,
                  correct: $data.correct
                }, null, 8, ["onOnChanged", "postaimqus", "correct"]))
              : _createCommentVNode("", true),
            ($data.flag == 'correct5')
              ? (_openBlock(), _createBlock(_component_correct5, {
                  key: 2,
                  onOnChanged: $options.updateCorrect,
                  postaimqus: $data.postaimqus,
                  correct: $data.correct
                }, null, 8, ["onOnChanged", "postaimqus", "correct"]))
              : _createCommentVNode("", true),
            ($data.flag == 'reason')
              ? (_openBlock(), _createBlock(_component_reason, {
                  key: 3,
                  onOnChanged: $options.reasonCorrect,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'jiexiao')
              ? (_openBlock(), _createBlock(_component_jiexiao, {
                  key: 4,
                  onOnChanged: $options.jiexiaoChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}